module.exports = __webpack_public_path__ + "static/media/male.a82ab1cd.png";